import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
type Buyer = {
  name: string;
  city: string;
  country: string;
};
const BUYERS: Buyer[] = [{
  name: 'Helen',
  city: 'Leeds',
  country: 'United Kingdom'
}, {
  name: 'Megan',
  city: 'Christchurch',
  country: 'New Zealand'
}, {
  name: 'Amelia',
  city: 'Perth',
  country: 'Australia'
}, {
  name: 'Priya',
  city: 'Calgary',
  country: 'Canada'
}, {
  name: 'Caroline',
  city: 'Edinburgh',
  country: 'United Kingdom'
}, {
  name: 'Sophie',
  city: 'Auckland',
  country: 'New Zealand'
}, {
  name: 'Jessica',
  city: 'Toronto',
  country: 'Canada'
}, {
  name: 'Emily',
  city: 'Melbourne',
  country: 'Australia'
}, {
  name: 'Rachel',
  city: 'Manchester',
  country: 'United Kingdom'
}, {
  name: 'Chloe',
  city: 'Wellington',
  country: 'New Zealand'
}, {
  name: 'Isla',
  city: 'Vancouver',
  country: 'Canada'
}, {
  name: 'Grace',
  city: 'Brisbane',
  country: 'Australia'
}, {
  name: 'Laura',
  city: 'Bristol',
  country: 'United Kingdom'
}, {
  name: 'Ruby',
  city: 'Montreal',
  country: 'Canada'
}, {
  name: 'Olivia',
  city: 'Sydney',
  country: 'Australia'
}];
const MINUTES = [2, 3, 5, 7, 8, 11, 14, 18];
export function PurchasePopup() {
  const [index, setIndex] = useState<number>(0);
  const [visible, setVisible] = useState<boolean>(false);
  const [dismissed, setDismissed] = useState<boolean>(false);
  useEffect(() => {
    if (dismissed) return;
    let hideId = 0;
    const showId = window.setInterval(() => {
      setVisible(true);
      hideId = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % BUYERS.length);
      }, 5000);
    }, 9000);
    const firstId = window.setTimeout(() => setVisible(true), 3500);
    return () => {
      window.clearInterval(showId);
      window.clearTimeout(hideId);
      window.clearTimeout(firstId);
    };
  }, [dismissed]);
  if (dismissed || !visible) return null;
  const buyer = BUYERS[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <div role="status" aria-live="polite" className="animate-pop-in fixed bottom-2 left-2 z-50 max-w-[250px] rounded-xl border-2 border-mustard bg-white p-2 pr-7 shadow-lg sm:max-w-[280px]" data-id="element-179" data-mp="2aqxlsogkcif9">
      <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-1 top-1 rounded-full p-0.5 text-muted transition-colors duration-150 ease-out hover:bg-sand hover:text-ink" data-id="element-180" data-mp="2kko6rjdheaq7">
        <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-181" data-mp="1wwwtodk49tnv" />
      </button>

      <div className="flex items-start gap-2" data-id="element-182" data-mp="1wv25mqdjtlfk">
        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta/15" data-id="element-183" data-mp="21vzsvhdf15nx">
          <CheckCircle2Icon className="h-4 w-4 text-cta" aria-hidden="true" data-id="element-184" data-mp="26o17h9y238h4" />
        </span>
        <div data-id="element-185" data-mp="196j0uktpjqs8">
          <p className="text-[11px] font-bold leading-tight text-ink" data-id="element-186" data-mp="196st6f286a13">
            {buyer.name} from {buyer.city}, {buyer.country}
          </p>
          <p className="text-[11px] leading-snug text-muted" data-id="element-187" data-mp="3rgyexi6nccf3">
            just purchased{' '}
            <span className="font-bold text-petrol" data-id="element-188" data-mp="3relxd64sw42k">Special Education Teacher Pro™</span>
          </p>
          <p className="text-[9px] uppercase tracking-wide text-muted/80" data-id="element-189" data-mp="3iga0imdcca1o">
            {minutes} minutes ago · Verified
          </p>
        </div>
      </div>
    </div>;
}